module.exports = __webpack_public_path__ + "media/images/landing/3-cd9d5c90dedbdfe8f2555a57b72d8152.png";